/**
 * Public types for @alchemiesolns/store-api.
 */

export type LicenseStatus = 'active' | 'past_due' | 'expired' | 'revoked';

export interface LicenseSummary {
  status: LicenseStatus;
  product: string;
  expiresAt: string | null;
  /** Present only when server considers the license usable (active / past_due). */
  key?: string;
}

export interface LicensesMeResponse {
  licenses: Record<string, LicenseSummary>;
}

export interface ValidateKeyDetailedResponse {
  valid: boolean;
  status?: LicenseStatus;
  product?: string;
  expiresAt?: string | null;
  reason?: string;
}

export type CheckoutIntent = 'yearly';

export interface StartCheckoutSessionInput {
  productId: string;
  intent: CheckoutIntent | string | null;
  successUrl: string;
  cancelUrl: string;
}

export interface StartPortalSessionInput {
  productId: string;
  returnUrl: string;
}

export interface UserProfileInput {
  name: string;
  institution?: string | null;
  marketingConsent?: boolean;
}

/** Serialized profile from GET `/userProfile` (timestamps as ISO strings). */
export interface UserProfileResponse {
  email: string | null;
  name: string | null;
  institution: string | null;
  marketingConsentAccepted: boolean | null;
  marketingConsentAcceptedAt: string | null;
  createdAt: string | null;
  updatedAt: string | null;
}

export type StoreApiErrorCode =
  | 'not-initialized'
  | 'not-configured'
  | 'not-signed-in'
  | 'network'
  | 'invalid-response'
  | 'server'
  | 'unknown';

export class StoreApiError extends Error {
  readonly code: StoreApiErrorCode;
  readonly status: number | undefined;
  constructor(code: StoreApiErrorCode, message: string, status?: number) {
    super(message);
    this.name = 'StoreApiError';
    this.code = code;
    this.status = status;
  }
}
